export default __webpack_public_path__ + "static/media/call-hold.f2496be8.svg";